/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_See_All_HintInputs */

const en_us2_search_see_all_hint = /** @type {(inputs: Search_See_All_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The whole catalogue, to filter as you like`)
};

const pt_br2_search_see_all_hint = /** @type {(inputs: Search_See_All_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O catálogo inteiro, para filtrar como quiser`)
};

const es_419_search_see_all_hint = /** @type {(inputs: Search_See_All_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El catálogo completo, para filtrar como quieras`)
};

const pt_pt2_search_see_all_hint = /** @type {(inputs: Search_See_All_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O catálogo inteiro, para filtrares como quiseres`)
};

const fr_fr2_search_see_all_hint = /** @type {(inputs: Search_See_All_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout le catalogue, à filtrer comme tu veux`)
};

const de_de2_search_see_all_hint = /** @type {(inputs: Search_See_All_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der ganze Katalog, frei filterbar`)
};

const it_it2_search_see_all_hint = /** @type {(inputs: Search_See_All_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto il catalogo, da filtrare come vuoi`)
};

/**
* | output |
* | --- |
* | "The whole catalogue, to filter as you like" |
*
* @param {Search_See_All_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_see_all_hint = /** @type {((inputs?: Search_See_All_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_See_All_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_see_all_hint(inputs)
	if (locale === "es-419") return es_419_search_see_all_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_search_see_all_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_search_see_all_hint(inputs)
	if (locale === "de-DE") return de_de2_search_see_all_hint(inputs)
	if (locale === "it-IT") return it_it2_search_see_all_hint(inputs)
	return en_us2_search_see_all_hint(inputs)
});
export { search_see_all_hint as "search.see_all_hint" }